module.exports = __webpack_public_path__ + "img/logo1.e135efd3.png";